import { Arts } from '../types/data/arts.d';

const arts: Arts = [
    {
        img: 'https://pbs.twimg.com/media/FRmAB6yagAI0br0.jpg',
        artist: {
            username: '@ElaineCelestia',
            url: 'https://twitter.com/ElaineCelestia',
        },
    },
    {
        img: 'https://pbs.twimg.com/media/Eu9cQWIU4AYZGex.jpg',
        artist: {
            username: '@AyumiAika_',
            url: 'https://twitter.com/AyumiAika_',
        },
    },
    {
        img: 'https://pbs.twimg.com/media/E44l9wLUcAcMSdz.jpg',
        artist: {
            username: '@Ikazu401',
            url: 'https://twitter.com/Ikazu401',
        },
    },
    {
        img: 'https://pbs.twimg.com/media/FN96pDoaAAIuEQs.jpg',
        artist: {
            username: '@deidey16_',
            url: 'https://twitter.com/deidey16_',
        },
    },
    {
        img: 'https://pbs.twimg.com/media/FRljGC3VsAAMgQK.jpg',
        artist: {
            username: '@Ikazu401',
            url: 'https://twitter.com/Ikazu401',
        },
    },
    {
        img: 'https://pbs.twimg.com/media/FXfleEFacAAwCVb.jpg',
        artist: {
            username: '@MerySyafira48',
            url: 'https://twitter.com/MerySyafira48',
        },
    },
    {
        img: 'https://pbs.twimg.com/media/E_jg_FKVUAAJOf_.jpg',
        artist: {
            username: '@aditchris',
            url: 'https://twitter.com/aditchris',
        },
    },
    {
        img: 'https://pbs.twimg.com/media/Ef14v6hUEAEn7yH.jpg',
        artist: {
            username: '@Acacia_Leafs',
            url: 'https://twitter.com/Acacia_Leafs',
        },
    },
    {
        img: 'https://pbs.twimg.com/media/EmJ8YMGVgAYQG3p.jpg',
        artist: {
            username: '@SakurarinMochi',
            url: 'https://twitter.com/SakurarinMochi',
        },
    },
    {
        img: 'https://pbs.twimg.com/media/FaUgYNOaAAE-PXG.jpg',
        artist: {
            username: '@pine_pinepin',
            url: 'https://twitter.com/pine_pinepin',
        },
    },
    {
        img: 'https://pbs.twimg.com/media/FZsxffAUYAEegeF.jpg',
        artist: {
            username: '@SakurarinMochi',
            url: 'https://twitter.com/SakurarinMochi',
        },
    },
    {
        img: 'https://pbs.twimg.com/media/EfnGLyOVoAEUOaf.jpg',
        artist: {
            username: '@UpMocks',
            url: 'https://twitter.com/UpMocks',
        },
    },
    {
        img: 'https://pbs.twimg.com/media/Fc_gzamaIAA108D.jpg',
        artist: {
            username: '@pine_pinepin',
            url: 'https://twitter.com/pine_pinepin',
        },
    },
];

export default arts;
